// @ts-nocheck
import { populate } from 'populate';
import type { Container, Sprite, Text } from 'pixi.js';

const raw = {
  list: [
    {
      id: '1ebaef8e-ce40-4637-87b5-eb0724a328d5',
      type: 'Container',
      name: 'root',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: ''
    },
    {
      id: '43abd412-3fa2-4fa3-803a-e7399982266f',
      type: 'Sprite',
      name: 'icon',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'large_coin',
      parent: '1ebaef8e-ce40-4637-87b5-eb0724a328d5',
      data: {
        maxSize: 80
      },
      stateByName: {
        withBubble: {
          x: 0
        }
      }
    },
    {
      id: 'a04bef60-1185-4e00-833e-bb093d67c8e8',
      type: 'Text',
      name: 'amountText',
      className: '',
      x: 52,
      y: 0,
      anchor: {
        x: 1,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'x79',
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 30,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: 'black',
        strokeThickness: 6,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: '1ebaef8e-ce40-4637-87b5-eb0724a328d5',
      stateByName: {
        withBubble: {
          x: 45
        }
      }
    },
    {
      id: '9bab77ce-8047-4c53-97f5-80be6f82a5f7',
      type: 'Sprite',
      name: 'bubble',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.7,
        y: 1.7
      },
      angle: 0,
      alpha: 0.3,
      visible: false,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Point_Bubble',
      parent: '1ebaef8e-ce40-4637-87b5-eb0724a328d5',
      stateByName: {
        withBubble: {
          visible: true
        }
      }
    }
  ],
  x: 0,
  y: 0,
  width: 760,
  height: 760,
  version: '2.0.0',
  stateNames: [
    'withBubble'
  ],
  handleResize: false
} as const;

export class InventoryItemAmountLayout {
  static raw = raw;
  root!: Container;
  icon!: Sprite & { data: typeof raw['list'][1]['data'] };
  amountText!: Text;
  bubble!: Sprite;
  StateName!: 'withBubble';

  constructor() {
    populate(this, raw);
  }
}
